import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × CEZANNE: Geometry before abstraction
// Planes, volumetric cubes, analytic brushwork
export function VasarelyCezanneMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Analytic background */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.deep} opacity="0.9" />

      <g transform="translate(397 540)">
        {/* Volumetric cube planes */}
        {Array.from({ length: 8 }).map((_, i) =>
          Array.from({ length: 10 }).map((_, j) => {
            const x = (i - 3.5) * 60;
            const y = (j - 4.5) * 60;
            const depth = Math.sin(i * 0.5) * Math.cos(j * 0.4) * 20;
            
            return (
              <g key={`${i}-${j}`}>
                {/* Top plane */}
                <path
                  d={`M ${x - 25} ${y - 25 + depth} L ${x + 25} ${y - 25 + depth} L ${x + 25 + depth} ${y - 25} L ${x - 25 + depth} ${y - 25} Z`}
                  fill={brand.aqua}
                  opacity={0.15 + Math.abs(depth) * 0.01}
                />
                {/* Front plane */}
                <rect
                  x={x - 25}
                  y={y - 25 + depth}
                  width="50"
                  height="50"
                  fill={brand.violet}
                  opacity={0.2}
                />
                {/* Side plane */}
                <path
                  d={`M ${x + 25} ${y - 25 + depth} L ${x + 25 + depth} ${y - 25} L ${x + 25 + depth} ${y + 25} L ${x + 25} ${y + 25 + depth} Z`}
                  fill={brand.amber}
                  opacity={0.15}
                />
              </g>
            );
          })
        )}

        {/* Analytic structure lines */}
        {Array.from({ length: 16 }).map((_, i) => {
          const angle = (i * Math.PI) / 8;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 280}
              y2={Math.sin(angle) * 280}
              stroke={brand.white}
              strokeWidth="0.5"
              opacity="0.15"
            />
          );
        })}

        {/* Geometric reduction circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 40 + i * 22;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
              strokeWidth="2"
              opacity={0.3 - i * 0.015}
            />
          );
        })}

        {/* Planar intersections */}
        {[
          { x: -140, y: -100, w: 120, h: 100, angle: 15 },
          { x: 130, y: -90, w: 110, h: 95, angle: -12 },
          { x: -110, y: 120, w: 100, h: 105, angle: -10 },
          { x: 140, y: 130, w: 115, h: 90, angle: 18 },
        ].map((plane, i) => (
          <g key={i}>
            <rect
              x={plane.x - plane.w / 2}
              y={plane.y - plane.h / 2}
              width={plane.w}
              height={plane.h}
              fill={brand.violet}
              opacity="0.15"
              transform={`rotate(${plane.angle} ${plane.x} ${plane.y})`}
            />
            <rect
              x={plane.x - plane.w / 2}
              y={plane.y - plane.h / 2}
              width={plane.w}
              height={plane.h}
              fill="none"
              stroke={brand.aqua}
              strokeWidth="2"
              opacity="0.4"
              transform={`rotate(${plane.angle} ${plane.x} ${plane.y})`}
            />
          </g>
        ))}

        {/* Order emerging nodes */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 200;
          return (
            <circle
              key={angle}
              cx={Math.cos(rad) * r}
              cy={Math.sin(rad) * r}
              r="10"
              fill={brand.amber}
              opacity="0.5"
            />
          );
        })}

        {/* Structural frame */}
        <rect x="-240" y="-220" width="480" height="440" fill="none" stroke={brand.aqua} strokeWidth="2" opacity="0.3" />
      </g>

      {/* Geometric inscription */}
      <text x="397" y="1000" textAnchor="middle" fontFamily="serif" fontSize="11" fill={brand.aqua} opacity="0.5">
        géométrie de la perception
      </text>
    </g>
  );
}
